import { AccordionData } from "@genericTypes/sharedTypes";
import React from "react";
import AccordionItem from "./AccordionItem";
import Head from "next/head";

const Accordion = ({
    title,
    data,
}: {
    title: string;
    data: AccordionData[];
}) => {
    function stripHtmlTags(input: string) {
        // Use a regular expression to remove HTML tags
        return input.replace(/<[^>]*>/g, "");
    }
    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    id="faq-schema"
                    dangerouslySetInnerHTML={{
                        __html: `
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [
                            ${data
                                .map((item) => {
                                    return `{
                                        "@type": "Question",
                                        "name": "${item.title}",
                                        "acceptedAnswer": {
                                            "@type": "Answer",
                                            "text": "${stripHtmlTags(
                                                item.content,
                                            )?.replace("\n", "")}"
                                        }
                                    }`;
                                })
                                .join(",")}
                            ]
                        }
                        `,
                    }}
                />
            </Head>
            <div className="flex flex-col">
                <div className="lg:text-3xl text-xl leading-10 font-extrabold lg:leading-[60px]">
                    {title}
                </div>
                <div className="flex flex-col gap-2">
                    {data.map((item) => (
                        <AccordionItem
                            key={item.id}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default Accordion;
